import { createContext, useMemo, useState } from "react";

export const AppContext = createContext({});

export function AppWrapper({ children }) {
  const [countries,setCountries] = useState([]);

  const contextValue = useMemo(() => {
    return [countries,setCountries]
  },[countries,setCountries]);

  return (
    <AppContext.Provider value={contextValue} >{children}</AppContext.Provider>
  );
}